import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

function autoVariant(value) {
  if (value <= 33) {
    return 'error'
  } else if (value <= 66) {
    return 'warning'
  }
  return 'success'
}

function convertToPercent(value, maxValue) {
  const percent = (value / maxValue) * 100
  return Math.round(percent)
}

const ProgressBar = ({ auto, maxValue, size, value, variant }) => {
  const convertedValue = convertToPercent(value, maxValue)

  const progressValue = {
    width: `${convertedValue}%`,
  }

  return (
    <ThemeProvider theme={theme}>
      <OuterBar className={size}>
        <InnerBar
          className={auto ? autoVariant(convertedValue) : variant}
          style={progressValue}
          role="progressbar"
          aria-valuenow={convertedValue}
          aria-valuemin="0"
          aria-valuemax={maxValue}
        />
      </OuterBar>
    </ThemeProvider>
  )
}

ProgressBar.defaultProps = {
  auto: false,
  maxValue: 100,
  size: 'small',
  value: 0,
  variant: 'info',
}

const OuterBar = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  background-color: #ccc;
  border-radius: 4px;
  &.small {
    height: 8px;
  }
  &.large {
    height: 16px;
  }
`

const InnerBar = styled.div`
  border-radius: 4px;
  transition: width 750ms;
  &.success {
    background-color: ${props => props.theme.status.successBg};
  }
  &.warning {
    background-color: ${props => props.theme.status.warningBg};
  }
  &.error {
    background-color: ${props => props.theme.status.errorBg};
  }
  &.info {
    background-color: ${props => props.theme.status.infoBg};
  }
`

export default ProgressBar
